<template>
  <el-dialog
    :title="addTitle == '' ? '新增片区' : '编辑片区'"
    :visible.sync="templeShowDialog"
    width="800px"
    style="height:400px,max-height:400px"
    center
    :append-to-body="true"
    @closed="closeDialog"
    v-drag
  >
    <SiruiSearch
      ref="baseInfoFormRef"
      :query="baseFormData"
      :columns="formColumn"
      :rules="formRules"
      :isQueryPanel="false"
    ></SiruiSearch>
    <div class="bottom">
      <el-button type="primary" @click="closeDialog" class="btn-cancer">取消</el-button>
      <el-button type="primary" @click="save" :loading="load" class="btn-save">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import '@/utils/directives.js';
  export default {
    name: 'AddAreaDialog',
    components: {
      SiruiSearch,
    },
    computed: {
      formColumn() {
        return [
          {
            prop: 'name',
            name: '片区名称',
            type: 'input',
            placeholder: '请输入片区名称',
            span: 24,
            maxlength: 20,
            disabled: this.isEnabled == 1,
          },
        ];
      },
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
      addTitle: {
        type: String,
        default: '',
      },
      isEnabled: {
        type: Number,
        dafault: 0,
      },
    },
    watch: {
      showDialog(var1, var2) {
        this.templeShowDialog = var2;
        this.templeShowDialog = var1;
      },
    },
    data() {
      return {
        templeShowDialog: this.showDialog,
        baseFormData: { name: this.addTitle },
        formRules: {
          name: [
            { required: true, message: '请输入片区名称', trigger: 'change' },
            { min: 2, max: 20, message: '请输入 2 到 20 个字符', trigger: 'blur' },
          ],
        },
        load: false,
      };
    },

    mounted() {},

    methods: {
      closeDialog() {
        this.$emit('closeDialog', false);
        this.load = false;
      },
      endLoading() {
        this.load = false;
      },
      save() {
        this.$refs.baseInfoFormRef.validate((value, data) => {
          if (value) {
            this.load = true;
            this.$emit('submit', data.name);
          }
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .title {
    font-size: 14px;
    color: black;
    margin-left: 10px;
  }
  .fixed-bottom-btn {
    padding: 0px 0px;
    background-color: #e0e5ff;
    color: #597aff;
    min-width: 60px;
    height: 26px;
    border: 0px solid #dcdfe6;
  }
  .info {
    margin-top: 15px;
    margin-left: 20px;
    color: red;
  }
  .bottom {
    margin-top: 20px;
    margin-bottom: 15px;
    text-align: center;
    .btn-cancer {
      padding: 0px 0px;
      background-color: #e0e5ff;
      color: #597aff;
      min-width: 80px;
      height: 30px;
      margin-right: 20px;
      border: 0px solid #dcdfe6;
    }
    .btn-save {
      padding: 0px 0px;
      background-color: #66b1ff;
      color: white;
      min-width: 80px;
      height: 30px;
      margin-left: 20px;
      border: 0px solid #dcdfe6;
    }
  }
</style>
